export default "__VITE_ASSET__Ce374VOF__"